<script>
  import fornecedorServico from '../servico';
  import Carregando from '~componentes/Carregando.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import { modal } from 'vue-strap';

  export default {
    components: { Carregando, Paginacao, DatePicker, modal, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        //pagina: 1,
        //totalRegistros: 0,
        //totalPaginas: 0,
        //registrosPorPagina: 0,

        arquivos: [],
        pesquisaPrecos: [],
        pesquisaPrecoSelecionada: {},
        solicitacaoPesquisaPreco: {},
        isPesquisaPrecoSelecionada: false,
        carregando: true,
        salvando: false,
        animated: true,
        //filtros: this.camposFiltros(),
        configuracao: this.$storage.configuracao(),
        idCompra: this.$route.params.id,
        formaPagamento: ['Dinheiro', 'Cartão']
      }
    },
    methods: {
      /*camposFiltros() {
        return {
          periodo: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {});

        this.lista();
      },*/
      solicitacao(idCompra) {
        this.carregando = true;
        return fornecedorServico.solicitacaoPesquisaPreco(idCompra)
          .then(res => {
            this.solicitacaoPesquisaPreco = res.body;
          })
          .then(() => fornecedorServico.arquivosSolicitacaoPesquisaPreco(idCompra))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.carregando = false;
          });
      },
      lista(pagina = 1) {
        this.carregando = true;

        return fornecedorServico.listaPesquisaPreco(pagina, this.idCompra/*, this.filtros*/)
          .then(res => {
            this.pesquisaPrecos = res.body.registros;
            //this.totalRegistros = res.body.totalRegistros;
            //this.totalPaginas = res.body.totalPaginas;
            //this.registrosPorPagina = res.body.registrosPorPagina;
          })
          .then(() => fornecedorServico.arquivosSolicitacaoPesquisaPreco(this.idCompra))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.carregando = false;
          });
      },
      statusPesquisaPreco(indice = -1) {
        if (indice > -1) {
          const pesquisa = this.pesquisaPrecos[indice];

          if (pesquisa.cancelaItemCompra) {
            return 'Item cancelado';
          }

          if (pesquisa.dataPesquisaWEBValidada !== '1899-12-30T00:00:00' || pesquisa.pesquisaValidada) {
            return 'Resposta validada';
          }

          const dataLimite = moment(this.solicitacaoPesquisaPreco.dataHoraLimitePesquisa);
          const dataAtual = moment();
          if (dataLimite.diff(dataAtual) < 0) {
            return 'Data limite atingida';
          }
        }
        return 'Disponível';
      },
      responder(indice) {
        this.pesquisaPrecoSelecionada = JSON.parse(JSON.stringify(this.pesquisaPrecos[indice]))
        this.pesquisaPrecoSelecionada.indice = indice;
        this.isPesquisaPrecoSelecionada = true;
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      adicionar() {
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].valorUnitario = this.pesquisaPrecoSelecionada.valorUnitario
          ? parseFloat(String(this.pesquisaPrecoSelecionada.valorUnitario).replace('.', '').replace(',', '.')) : 0.00;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].descontoPercentual = this.pesquisaPrecoSelecionada.descontoPercentual
          ? parseFloat(String(this.pesquisaPrecoSelecionada.descontoPercentual).replace('.', '').replace(',', '.')) : 0.00;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].descontoDinheiro = this.pesquisaPrecoSelecionada.descontoDinheiro
          ? parseFloat(String(this.pesquisaPrecoSelecionada.descontoDinheiro).replace('.', '').replace(',', '.')) : 0.00;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].valorFrete = this.pesquisaPrecoSelecionada.valorFrete
          ? parseFloat(String(this.pesquisaPrecoSelecionada.valorFrete).replace('.', '').replace(',', '.')) : 0.00;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].quantidadeCaixa = this.pesquisaPrecoSelecionada.quantidadeCaixa || 0;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].formaPagamento = this.pesquisaPrecoSelecionada.formaPagamento;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].ipiPesquisa = this.pesquisaPrecoSelecionada.ipiPesquisa
          ? parseFloat(String(this.pesquisaPrecoSelecionada.ipiPesquisa).replace('.', '').replace(',', '.')) : 0.00;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].prazoEntrega = this.pesquisaPrecoSelecionada.prazoEntrega || 0;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].marca = this.pesquisaPrecoSelecionada.marca;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].modelo = this.pesquisaPrecoSelecionada.modelo;
        this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice].observacaoPesquisa = this.pesquisaPrecoSelecionada.observacaoPesquisa || '';

        this.salvarIndividual(this.pesquisaPrecos[this.pesquisaPrecoSelecionada.indice]);

        this.pesquisaPrecoSelecionada = {};
        this.isPesquisaPrecoSelecionada = false;
      },
      fecharModal() {
        this.pesquisaPrecoSelecionada = {};
        this.isPesquisaPrecoSelecionada = false;
        this.salvando = false;
      },
      /*salvar() {
        return fornecedorServico
          .responderPesquisaPrecos(this.pesquisaPrecos)
          .then(dados => {
            this.lista();

            $('#salvar').button('reset');
            toastr.success(`Pesquisa respondida com sucesso.`);
          })
          .catch(erro => {
            $('#salvar').button('reset');

            this.$mensagemErro(erro);
          });
      },*/
      mostrarConfirmacaoSalvarArquivos() {
        this.$swal({
          title: 'Sucesso',
          html: 'Orçamento(s) enviado(s) com sucesso!',
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      async salvarSolicitacaoPesquisaPreco() {
        this.salvando = true;
        $('#salvar_arquivo').button('loading');

        const arquivosNovos = this.$refs.adicionarArquivos.arquivos;
        const arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (
          (arquivosNovos && arquivosNovos.length > 0 && arquivosNovos[0]) ||
          (arquivosDeletados && arquivosDeletados.length > 0)
        ) {
          await fornecedorServico.alterarSolicitacaoPesquisaPreco(
            this.idCompra,
            arquivosNovos, arquivosDeletados);

          await this.solicitacao(this.idCompra);
          await this.lista();
          this.$refs.adicionarArquivos.limparArquivos();
          this.$refs.listaArquivos.deletados = [];

          $('#tabs a[href="#tab-itens-pesquisa"]').tab('show');
        }

        $('#salvar_arquivo').button('reset');
        this.salvando = false;

        this.mostrarConfirmacaoSalvarArquivos();
      },
      salvarIndividual(pesquisaPreco) {
        this.salvando = true;
        return fornecedorServico
          .responderPesquisaPreco(pesquisaPreco)
          .then(dados => {
            this.lista();

            this.salvando = false;
            this.animated = false;
            // $('#salvar').button('reset');
            toastr.success(`Pesquisa respondida com sucesso.`);
          })
          .catch(erro => {
            this.salvando = false;
            // $('#salvar').button('reset');

            this.$mensagemErro(erro);
          });
      },
      download(arquivo) {
        fornecedorServico
          .downloadSolicitacaoPesquisaPreco(this.idCompra, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      /*mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },*/
    },
    async mounted() {
      await this.solicitacao(this.idCompra);
      await this.lista(/*this.pagina*/);

      this.animated = false;

      this.$root.tituloDaPagina = `Pesquisas de Preço - Solicitação ${this.solicitacaoPesquisaPreco.solicitacaoCompra}`;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      const _this = this;
    },
    watch: {
      '$route': 'lista',
    },
    computed: {
      show() {
        return this.isPesquisaPrecoSelecionada;
      },
      pesquisaCancelada() {
        if ('cancelaItemCompra' in this.pesquisaPrecoSelecionada) {
          return this.pesquisaPrecoSelecionada.cancelaItemCompra;
        }
        return false;
      },
      pesquisaValidada() {
        if ('dataPesquisaWEBValidada' in this.pesquisaPrecoSelecionada) {
          return (this.pesquisaPrecoSelecionada.dataPesquisaWEBValidada !== '1899-12-30T00:00:00'
            || this.pesquisaPrecoSelecionada.pesquisaValidada);
        }
        return false;
      },
      passouLimite() {
        const dataLimite = moment(this.solicitacaoPesquisaPreco.dataHoraLimitePesquisa);
        const dataAtual = moment();

        return dataLimite.diff(dataAtual) < 0;
      }
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">

          <!--<div class="ibox-title pointer" @click="mostrarEsconderFiltro">
          <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

          <div class="ibox-tools">
            <span class="collapse-link">
              <i class="fa fa-chevron-up"></i>
            </span>
          </div>
        </div>

        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label">Período</label>

                <date-picker v-model="filtros.periodo"
                             input-class="form-control"
                             range
                             :editable="false"
                             lang="pt-br"
                             :confirm="true"
                             range-separator="a"
                             format="DD/MM/YYYY"
                             :shortcuts="false">
                </date-picker>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group no-margins">
                <button type="button" class="btn btn-primary no-margins" @click="lista">
                  <i class="fa fa-search"></i>
                  Filtrar
                </button>
                <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                  <i class="fa fa-eraser"></i>
                  Limpar filtros
                </button>
              </div>
            </div>
          </div>
        </div>-->

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-itens-pesquisa">
                  Itens da pesquisa
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>

            <div class="tab-content">
              <div id="tab-itens-pesquisa" class="tab-pane active">
                <div class="panel-body">
                  <div class="table-responsive">
                    <table class="table table-hover table-pointer">
                      <thead>
                        <tr>
                          <th style="display: none">Número</th>
                          <th>Produto ou Serviço</th>
                          <th>Quantidade</th>
                          <th>Valor Unitário (R$)</th>
                          <th>Desconto (%)</th>
                          <th>Desconto (R$)</th>
                          <th>Frete (R$)</th>
                          <th>Valor IPI</th>
                          <th>Forma de Pagamento</th>
                          <th>Prazo de Entrega</th>
                          <th>Data De Resposta da Pesquisa</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(pesquisaPreco, indice) in pesquisaPrecos">
                          <td class="text-center" style="display: none">{{ pesquisaPreco.idPesquisa || '---' }}</td>
                          <td>{{ pesquisaPreco.nomeProduto + ' - ' + pesquisaPreco.complemento || '---' }}</td>
                          <td>{{ pesquisaPreco.quantidade || '---' }}</td>
                          <td>{{ pesquisaPreco.valorUnitario | formatarNumero }}</td>
                          <td>{{ pesquisaPreco.descontoPercentual || '---' }}</td>
                          <td>{{ pesquisaPreco.descontoDinheiro | formatarNumero }}</td>
                          <td>{{ pesquisaPreco.valorFrete | formatarNumero }}</td>
                          <td>{{ pesquisaPreco.ipiPesquisa | formatarNumero }}</td>
                          <td>{{ pesquisaPreco.formaPagamento || '---' }}</td>
                          <td>{{ pesquisaPreco.prazoEntrega || '---' }}</td>

                          <td v-if="pesquisaPreco.dataRespPesquisa !== '1899-12-30T00:00:00'">{{ pesquisaPreco.dataRespPesquisa | formatarData }}</td>
                          <td v-else>{{ 'Não respondido' }}</td>

                          <td>{{ statusPesquisaPreco(indice) }}</td>

                          <td class="action">
                            <button type="button"
                                    class="btn btn-warning btn-xs"
                                    @click="responder(indice)">
                              <i class="fa fa-edit"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-show="carregando">
                          <td colspan="8">
                            <i class='fa fa-spinner fa-pulse'></i> Carregando...
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="!carregando">
      <div class="col-xs-9">
        <div class="form-group">
          <router-link class="btn btn-default"
                       :to="{ name: 'fornecedor.solicitacao-pesquisa-preco' }"
                       active-class="">
            <i class="fa fa-arrow-left"></i>
            Voltar
          </router-link>

          <button id="salvar_arquivo"
                  type="button"
                  class="btn btn-primary"
                  @click="salvarSolicitacaoPesquisaPreco"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i>
            Salvar Arquivos
          </button>

          <!--<button id="salvar"
                  type="button"
                  class="btn btn-primary"
                  @click="salvar"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i>
            Salvar
          </button>-->
        </div>
      </div>
    </div>

    <div>
      <modal ref="modal"
             :value="show"
             :large=true
             :backdrop="false">
        <div slot="modal-header" class="modal-header hide"></div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="control-label" for="descricao">Produto ou Serviço</label>

              <p>{{ pesquisaPrecoSelecionada.nomeProduto + ' - ' + pesquisaPrecoSelecionada.complemento }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label class="control-label" for="quantidade">Quantidade</label>

              <p>{{ pesquisaPrecoSelecionada.quantidade }}</p>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group required" :class="{'has-error': errors.has('valorUnitario')}">
              <label class="control-label" for="valorUnitario">Valor Unitário</label>

              <input type="text"
                     class="form-control text-right"
                     id="valor-unitario"
                     v-model="pesquisaPrecoSelecionada.valorUnitario"
                     data-vv-name="valorUnitario"
                     data-vv-as="valor unitário"
                     v-validate="'required'"
                     v-mascara="'moeda'">

              <p class="text-danger" v-show="errors.has('valorUnitario')">{{ errors.first('valorUnitario') }}</p>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group" :class="{'has-error': errors.has('descontoPercentual')}">
              <label class="control-label" for="descontoPercentual">Desconto Percentual (%)</label>

              <input type="text"
                     class="form-control text-right"
                     id="desconto-percentual"
                     v-model="pesquisaPrecoSelecionada.descontoPercentual"
                     data-vv-name="descontoPercentual"
                     data-vv-as="desconto percentual"
                     v-mascara="'moeda'">

              <p class="text-danger" v-show="errors.has('descontoPercentual')">{{ errors.first('descontoPercentual') }}</p>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group" :class="{'has-error': errors.has('descontoDinheiro')}">
              <label class="control-label" for="descontoDinheiro">Desconto Dinheiro</label>

              <input type="text"
                     class="form-control text-right"
                     id="desconto-dinheiro"
                     v-model="pesquisaPrecoSelecionada.descontoDinheiro"
                     data-vv-name="descontoDinheiro"
                     data-vv-as="desconto dinheiro"
                     v-mascara="'moeda'">

              <p class="text-danger" v-show="errors.has('descontoDinheiro')">{{ errors.first('descontoDinheiro') }}</p>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-lg-3">
            <div class="form-group required" :class="{'has-error': errors.has('valorFrete')}">
              <label class="control-label" for="valorFrete">Valor Frete</label>

              <input type="text"
                     class="form-control text-right"
                     id="valor-frete"
                     v-model="pesquisaPrecoSelecionada.valorFrete"
                     data-vv-name="valorFrete"
                     data-vv-as="valor frete"
                     v-validate="'required'"
                     v-mascara="'moeda'">

              <p class="text-danger" v-show="errors.has('valorFrete')">{{ errors.first('valorFrete') }}</p>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group required" :class="{'has-error': errors.has('formaPagamento')}">
              <label class="control-label" for="formaPagamento">Forma de Pagamento</label>

              <input type="text"
                     class="form-control"
                     id="forma-pagamento"
                     maxlength="150"
                     v-model="pesquisaPrecoSelecionada.formaPagamento"
                     data-vv-name="formaPagamento"
                     data-vv-as="forma pagamento"
                     v-validate="'required'">

              <p class="text-danger" v-show="errors.has('formaPagamento')">{{ errors.first('formaPagamento') }}</p>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group">
              <label class="control-label" for="quantidadeCaixa">Quantidade/Caixa</label>

              <input type="text"
                     class="form-control"
                     id="quantidade-caixa"
                     v-model="pesquisaPrecoSelecionada.quantidadeCaixa"
                     data-vv-name="quantidadeCaixa"
                     data-vv-as="quantidade caixa"
                     maxlength="4">
            </div>
          </div>

          <div class="col-lg-3">
            <div class="form-group">
              <label class="control-label" for="ipiPesquisa">IPI (%)</label>

              <input type="text"
                     class="form-control text-right"
                     id="ipi-pesquisa"
                     v-model="pesquisaPrecoSelecionada.ipiPesquisa"
                     data-vv-name="ipiPesquisa"
                     data-vv-as="ipi pesquisa"
                     v-mascara="'moeda'">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label class="control-label" for="prazoEntrega">Entrega (Dias)</label>

              <input type="text"
                     class="form-control"
                     id="prazo-entrega"
                     v-model="pesquisaPrecoSelecionada.prazoEntrega"
                     data-vv-name="prazoEntrega"
                     data-vv-as="prazo entrega"
                     maxlength="2">
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-lg-4">
            <div class="form-group" :class="{'has-error': errors.has('marca')}">
              <label class="control-label" for="marca">Marca</label>

              <input type="text"
                     class="form-control"
                     id="marca"
                     maxlength="40"
                     v-model="pesquisaPrecoSelecionada.marca"
                     data-vv-name="marca"
                     data-vv-as="marca">

              <p class="text-danger" v-show="errors.has('marca')">{{ errors.first('marca') }}</p>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="form-group" :class="{'has-error': errors.has('modelo')}">
              <label class="control-label" for="modelo">Modelo</label>

              <input type="text"
                     class="form-control"
                     id="modelo"
                     maxlength="80"
                     v-model="pesquisaPrecoSelecionada.modelo"
                     data-vv-name="modelo"
                     data-vv-as="modelo">

              <p class="text-danger" v-show="errors.has('modelo')">{{ errors.first('modelo') }}</p>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="control-label" for="observacaoPesquisa">Observação</label>

              <input type="text"
                     class="form-control"
                     id="observacao-pesquisa"
                     maxlength="80"
                     v-model="pesquisaPrecoSelecionada.observacaoPesquisa"
                     data-vv-name="observacaoPesquisa"
                     data-vv-as="observacao pesquisa">

              <p class="text-danger" v-show="errors.has('observacaoPesquisa')">{{ errors.first('observacaoPesquisa') }}</p>
            </div>
          </div>
        </div>

        <!--<div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <button type="button"
                      class="btn btn-success"
                      @click="validar">
                <i class="fa fa-plus"></i> Responder Item
              </button>
            </div>
          </div>
        </div>-->

        <div slot="modal-footer" class="modal-footer">
          <button v-if="!passouLimite && !pesquisaValidada && !pesquisaCancelada" type="button" class="btn btn-primary" @click="validar">
            <i class="fa fa-check"></i> Responder
          </button>
          <button type="button" class="btn btn-default" @click="fecharModal">
            <i class="fa fa-times"></i> Fechar
          </button>
        </div>
      </modal>
    </div>

  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/PesquisaPrecoLista.vue